import { Button } from "@components/ui/base/button"
import { useSliceContext } from "@components/SliceProvider"

export const IRREVERSIBLE_VIEW = () => {
  const { setModalView } = useSliceContext()
  return (
    <>
      <div className="sl-pb-6 sl-text-center">
        <h1 className="sl-fonts">Be careful</h1>
      </div>
      <div className="sl-text-center">
        <p className="sl-pb-4">
          You won&apos;t be able to change the name, description and image of
          your slicer a second time.
        </p>
        <p className="sl-font-bold sl-text-yellow-600">
          Make sure the slicer details and image are correct
        </p>
      </div>
      <div className="sl-flex sl-justify-center sl-pt-8">
        <Button onClick={() => setModalView({ name: "" })}>Continue</Button>
      </div>
    </>
  )
}

export default IRREVERSIBLE_VIEW
